import { HardBreak as TiptapHardBreak } from '@tiptap/extension-hard-break';

// Extend the HardBreak extension
export const HardBreak = TiptapHardBreak.extend({
    addKeyboardShortcuts() {
        const defaultShortcuts = this.parent?.() ?? {};
        // Override the default 'Mod-Enter' shortcut to prevent it from inserting a hard break
        //  This is to prevent conflicts with other shortcuts that might use 'Mod-Enter'
        delete defaultShortcuts?.['Mod-Enter'];

        return defaultShortcuts;
    },
});
